// Nadrama <https://nadrama.com>
// Copyright Nadrama Pty Ltd
// All rights reserved.
import { Show } from "solid-js";

export function DefaultShell(p: { children: unknown }) {
  return (
    <main class="brand min-h-screen p-4 sm:p-10">
      <div class="mx-auto max-w-xl pt-[6vh]">
        <img
          src="/images/nadrama-nav-logo.png"
          alt="Nadrama"
          class="mx-auto mb-8 h-11"
        />
        <section class="panel p-6 sm:p-9">{p.children as never}</section>
      </div>
    </main>
  );
}
export const Heading = (p: { title: string; copy?: string; action?: unknown }) => {
  const providers = p.title === "Providers";
  const title = providers ? "Cloud Providers" : p.title;
  const copy =
    p.copy ??
    (providers
      ? "Connecting a supported provider allows Nadrama to run managed nodes in your account."
      : undefined);
  return (
    <header class="mb-7 flex flex-wrap items-start justify-between gap-4">
      <div>
        <h1 class="page-title text-3xl font-semibold">{title}</h1>
        <Show when={copy}>
          <p class="mt-2 max-w-3xl text-slate-600">{copy}</p>
        </Show>
      </div>
      {p.action as never}
    </header>
  );
};
